module.exports = __webpack_public_path__ + "images/facebook_open_graph.png";